import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/logo.svg";
import GoogleIcon from "../assets/google.png";
import AppleIcon from "../assets/Apple.png";
import "../styles/LoginPage.css";
import Loader from "../components/Loader";
import { App as CapacitorApp } from "@capacitor/app"; // Import Capacitor's App plugin
import UrlHandlerService from "../services/UrlHandlerService";

interface LoginPageProps {
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoginPage: React.FC<LoginPageProps> = ({ setIsAuthenticated }) => {
  const {
    error,
    email,
    setEmail,
    password,
    setPassword,
    isLoggedIn,
    handleLogin,
    handleLogout,
    handleGoogleSignIn,
    showModal,
    handleContinue,
    signInWithFirebase,
  } = useAuth(setIsAuthenticated);

  const navigate = useNavigate();

  const isSignInWithGoogle = window.location.href.includes(
    "sign-in-with-google"
  );
  const isStripePayment = window.location.href.includes("stripe-payment");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const urlHandler = UrlHandlerService.getInstance();
    
    const handleGoogleSignIn = async (url: URL) => {
      const id = url.searchParams.get("id");
      const token = url.searchParams.get("token");
      
      if (id === 'google' && token) {
        setIsLoading(true);
        await signInWithFirebase(token);
        setIsLoading(false);
      }
    };

    urlHandler.registerHandler('login-google', handleGoogleSignIn);

    return () => {
      urlHandler.removeHandler('login-google');
    };
  }, [signInWithFirebase]);

  if (isSignInWithGoogle || isStripePayment) {
    return <div></div>;
  }

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    await handleLogin(e);
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <Logo />
        </div>
        {!isLoggedIn && (
          <form onSubmit={handleFormSubmit}>
            <input
              type="text"
              placeholder="Email"
              className="input-field"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <input
              type="password"
              placeholder="Password"
              className="input-field"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            {error && <p className="label-error">{error}</p>}
            {isLoading ? <Loader /> : ""}
            <div className="button-container">
              <button
                type="submit"
                disabled={isLoading}
                className="button button-primary"
              >
                Sign in
              </button>
              <button
                type="button"
                onClick={() => navigate("/signup")}
                className="button button-outline"
              >
                Sign up
              </button>
            </div>
          </form>
        )}
        <Link to="/forgot-password" className="forgot-password">
          forgot password?
        </Link>
        {/* <button className="google-button" onClick={handleGoogleSignIn}>
          <img src={AppleIcon} alt="Apple Logo" className="google-icon" />
          Sign in with Apple
        </button> */}
        <button className="google-button" onClick={handleGoogleSignIn}>
          <img src={GoogleIcon} alt="Google Logo" className="google-icon" />
          Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
